import React from "react";
import { Box, Button, Modal } from "@mui/material";
import { Button as Btn, Typography } from "@material-ui/core";
import Project from "../../model/project";
import ProfileIcon from "../../assets/admin/profile-icon.svg";
import CalendarIcon from "../../assets/admin/calendar-icon.svg";
import TimeIcon from "../../assets/admin/time-icon.svg";
import useStyles from "./styles";
import Avatar from "../../shared/components/images/Avatar";
import DateConverter from "../../utils/DateConverter";

const ProjectCard = ({ project, isRow, handleOpen }: any) => {
  const classes = useStyles();

  return (
    <div>
      {project.assignedTo == null ? (
        <div className={classes.itemGrid} key={project.id} onClick={handleOpen}>
          <div className={classes.itemHeader}>
            <Avatar name={project.createdBy} />
            <Typography className={classes.priceText}>
              ${project.rate}
            </Typography>
          </div>
          <div className={classes.itemBody}>
            <Typography className={classes.title}>{project.name}</Typography>
            <Typography
              className={classes.description}
              style={{ maxWidth: isRow ? "450px" : "1200px" }}
            >
              {project.description}
            </Typography>
          </div>
          <div className="d-flex col mt-2 align-items-center">
            <div className="d-flex col">
              <img src={CalendarIcon} className={classes.icon} alt="calendar" />
              <Typography className={classes.time}>
                {DateConverter.toMonthNameDateAndYear(project.startDate)}
              </Typography>
            </div>
            {project.User ? (
              <Avatar name={project.User?.firstName} />
            ) : (
              <img src={ProfileIcon} className={classes.img} alt="profile" />
            )}
          </div>
          <div className="d-flex col align-items-center">
            <img src={TimeIcon} className={classes.icon} alt="time" />
            <Typography className={classes.time}>
              {DateConverter.toHoursAndMinutes(project.createdAt)}
            </Typography>
          </div>
          <div
            className={classes.buttonDiv}
            style={{ marginTop: isRow ? "5%" : "0%" }}
          >
            <Btn className={classes.button} onClick={handleOpen}>
              Apply now
            </Btn>
          </div>
        </div>
      ) : (
        <div className={classes.takenDiv} key={project.id}>
          <div className={classes.takenSubDiv}>
            <Typography className={classes.takenTitle}>Taken by</Typography>
            <Avatar
              name={`${project.User?.firstName} ${project.User?.lastName}`}
              size={65}
              fontSize={20}
            />
            <div className="d-flex col align-items-center">
              <div className="d-flex row">
                <img src={TimeIcon} className={classes.icon} alt="time" />
                <Typography
                  className={classes.time}
                  style={{ marginTop: "10px" }}
                >
                  {DateConverter.toMonthNameDateAndYear(project.startDate)}
                </Typography>
                <Typography className={classes.time}>
                  {DateConverter.toHoursAndMinutes(project.createdAt)}
                </Typography>
              </div>
            </div>
          </div>
          <div
            className={classes.buttonDiv}
            style={{ marginTop: isRow ? "5%" : "0%" }}
          >
            <Btn className={classes.button} onClick={handleOpen}>
              Show details
            </Btn>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectCard;
